import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Button } from 'antd';
import Moment from 'react-moment';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import {
  Text, Box, ForEach, ShowIf,
} from '../../shared/components';
import BackgroundColorContainer from '../components/other/BackgroundColorContainer';
import CanalListItem from '../components/dataDisplay/CanalListItem';
import { obtenerChatsDesdeServidor } from '../../../state/actions/creators/giotalk.actioncreator';

class GIOTalkPage extends React.Component {
  componentDidMount() {
    const { obtenerChatsDesdeServidor } = this.props;
    obtenerChatsDesdeServidor();
  }

  render() {
    const { chats, notificaciones } = this.props;

    const chatsOrdenados = chats.sort((chatA, chatB) => {
      const { createdAt: createdAtA, lastMessage: lastMessageA } = chatA;
      const { createdAt: createdAtB, lastMessage: lastMessageB } = chatB;
      const { date: messageDateA } = lastMessageA || { date: undefined };
      const { date: messageDateB } = lastMessageB || { date: undefined };

      const dateA = (messageDateA !== undefined) ? messageDateA : createdAtA;
      const dateB = (messageDateB !== undefined) ? messageDateB : createdAtB;

      if (new Date(dateA).getTime() > new Date(dateB).getTime()) return -1;
      return 1;
    });

    return (
      <BackgroundColorContainer color="#063340">
        <Box p="16">
          <Box style={{ borderBottom: '1px solid #1d586f' }} pb="16">
            <TwoColumnsFlexLayout
              leftContent={<Text fontSize="24" color="white">Comunicaciones</Text>}
              rightContent={(
                <Link to="/talk/chats/crear">
                  <Button
                    ghost
                    type="default"
                    style={{ float: 'right' }}
                  >
                    Nuevo chat
                  </Button>
                </Link>
              )}
            />
          </Box>
          <CanalListItem esNotificacion canal={notificaciones} link="/talk/notificaciones" />
          <ForEach
            items={chatsOrdenados}
            render={(chat) => {
              const { id, lastMessage, createdAt } = chat;
              const { content, date } = lastMessage || { content: ' ', date: createdAt };
              const link = `/talk/chats/${id}/mostrar`;
              return (
                <CanalListItem
                  canal={chat}
                  link={link}
                  descripcion={content}
                  date={(
                    <ShowIf condition={date !== null}>
                      <Box>
                        <Box><Moment format="D/M/Y" date={date} /></Box>
                      </Box>
                    </ShowIf>
                  )}
                />
              );
            }}
          />
        </Box>
      </BackgroundColorContainer>
    );
  }
}

const mapStateToProps = ({ giotalk: { chats, notificaciones } }) => ({
  chats,
  notificaciones,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

    obtenerChatsDesdeServidor,

  }, dispatch);
}


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GIOTalkPage);
